import { Component, Input } from '@angular/core';
import { CollectorListItem } from '../../../domain/collector-profile.model';

@Component({
  selector: 'app-collector-identity-card',
  templateUrl: './collector-identity-card.component.html',
  styleUrls: ['../collector-card.shared.css']
})
export class CollectorIdentityCardComponent {
  @Input() collector!: CollectorListItem;
  @Input() showProfileFields = false;
}
